import { DependencyList, useEffect, useRef, useState } from 'react';

import { logError } from '@gn-audio/jss-core';

export const useAsync = <T>(callback: () => Promise<T>, deps?: DependencyList): T | undefined => {
  const [value, setValue] = useState<T>();

  const pending = useRef(0);
  useEffect(() => {
    const callNumber = pending.current + 1;
    pending.current = callNumber;
    callback()
      .then((value) => {
        if (callNumber === pending.current) {
          setValue(value);
        }
      })
      .catch((error) => logError('Server error', error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return value;
};
